import { forwardRef } from 'react'

import { EditorContent } from '@tiptap/react'

import { useEditor } from './use-editor'

export const MessageEditor = forwardRef<HTMLDivElement, object>(
  (props, ref) => {
    const { editor } = useEditor()

    return (
      <div>
        <EditorContent
          data-testid="message-editor"
          className="!outline-none"
          ref={ref}
          editor={editor}
        />
      </div>
    )
  },
)

MessageEditor.displayName = 'MessageEditor'
